"use client";

import Modal from "@/components/ui/modal";
import { TCommunityFeedPost } from "@/types/post";
import PostComments from "../../post/components/comments/comments";
import FeedPost from "./feed-post";

type TFeedPostModalProps = {
	open: boolean;
	setOpen: (state: boolean) => void;
	post: TCommunityFeedPost;
};

const FeedPostModal = ({ open, setOpen, post }: TFeedPostModalProps) => {
	return (
		<Modal isOpen={open} onClose={() => setOpen(false)} className="max-w-4xl">
			<FeedPost post={post} classNames={{ card: "p-0 shadow-none" }} uiType="FULL" />

			<div className="mt-6" />

			<PostComments post={post} />
		</Modal>
	);
};

export default FeedPostModal;
